import { useGetBreakpoint } from '@moonpig/web-shared-utils'
import { useExperiment } from '@moonpig/web-core-eppo/browser'
import { useMemo } from 'react'
import { TilesPerRow } from '../../types'

export const TILES_PER_ROW: TilesPerRow = {
  xs: 2,
  sm: 2,
  md: 3,
  lg: 4,
  xl: 5,
  xxl: 5,
}

const EXPERIMENT_KEY = 'search-four-column-product-grid'

export const useNumberOfTilesPerRow = () => {
  const breakpoint = useGetBreakpoint()
  const experimentVariant = useExperiment(EXPERIMENT_KEY, {
    fallback: 'control',
  })?.toLowerCase()

  const tilesPerRow: TilesPerRow = useMemo(() => {
    const isFourColumnVariant = experimentVariant === 'variant'
    return {
      ...TILES_PER_ROW,
      xl: isFourColumnVariant ? 4 : 5,
      xxl: isFourColumnVariant ? 4 : 5,
    }
  }, [experimentVariant])

  const currentTilesPerRow = tilesPerRow[breakpoint]

  return { tilesPerRow, currentTilesPerRow }
}
